import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OpportunityComponent } from './opportunity.component';
import { OpportunityService } from './opportunity.service';
import { FeatureToggleClient, SettingsClient } from 'api-clients/sales-api-client';

@NgModule({
  declarations: [
    OpportunityComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    OpportunityComponent,
  ],
  providers: [
    OpportunityService,
    { provide: FeatureToggleClient, useValue: new FeatureToggleClient() },
    { provide: SettingsClient, useValue: new SettingsClient() },
  ],
})
export class OpportunityModule { }
